import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DialogInputBase } from '../../../models/DialogData';
import { LinebreaksPipe } from '../../../pipes/linebreaks.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-notification-handler-dialog',
  templateUrl: './notification-handler-dialog.component.html',
  styleUrls: ['./notification-handler-dialog.component.scss'],
   imports:[
      MatButtonModule,
      MatDialogActions, 
      MatDialogClose, 
      MatDialogTitle, 
      MatDialogContent, 
      MatFormFieldModule,
      ReactiveFormsModule,
      MatInputModule,
      LinebreaksPipe,
      CommonModule,
      TranslatePipe
    ]
})

export class NotificationHandlerDialogComponent {

  constructor(public dialogRef : MatDialogRef<NotificationHandlerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogInputBase) {}


    onConfirmClick() {
        this.dialogRef.close();
      }
    
}
